export default __webpack_public_path__ + "static/media/H4009.1.98d2a8e9.mp3";